module.exports = __webpack_public_path__ + "img/openBox-red.9ec760e0.png";